import { Resource as e, API as r } from "@coveo/platform-client";
const t = class t extends e {
  list(s, i) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/${s}/evaluations`, i)
    );
  }
  get(s, i) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/${s}/evaluations/${i}`)
    );
  }
};
t.baseUrl = `/rest/organizations/${r.orgPlaceholder}/answer/v1/configs`;
let a = t;
export {
  a as AnswerEvaluationResource
};
//# sourceMappingURL=AnswerEvaluationResource.js.map
